<!-- eslint-disable vue/no-parsing-error -->
<template>
  <van-popup round position="bottom" class="van-popup-wrapper" v-model="isShowGoodList" @click-overlay="closePop">
    <div class="snap-up">
      <div class="top com-half-line">
        <div class="title">
          <h3>正在抢购</h3>
          <p>
            跟着卡家直播抢购
          </p>
        </div>
        <div class="operate ask" @click="toCall">
          <i>&#xe602;</i>
          <span>咨询</span>
        </div>
        <div class="operate" @click="jumpOuterPage({ fullPath: 'https://maiche-test.m.360che.com/#/orderList' })">
          <i>&#xe601;</i>
          <span>订单</span>
        </div>
      </div>
      <!-- 下拉刷新 -->
      <div class="list">
        <!-- 初始页面loading -->
        <page-loading v-if="pageLoading"></page-loading>
        <van-pull-refresh v-model="isLoading" @refresh="getCartList('refresh')">
          <!-- 下拉提示 -->
          <template #pulling>
            <div class="pulling-box">
              <img class="pulling-img" src="https://s.kcimg.cn/live/json/pull-down-refresh/images/refresh_1.png" />
            </div>
          </template>
          <!-- 释放提示 -->
          <template #loosing>
            <div class="pulling-box">
              <img class="pulling-img" src="https://s.kcimg.cn/live/json/pull-down-refresh/images/refresh_1.png" />
            </div>
          </template>
          <!-- 加载提示 -->
          <template #loading>
            <pull-down></pull-down>
          </template>
          <div class="snap-up-list" v-if="goodList.length">
            <div  :class="{ 'item-living': +item.is_living }" v-for="(item, index) in goodList" :key="item.id">
              <div class="item" :class="{ 'is-living': +item.is_living }"
                @click="jumpOuterPage({ fullPath: item.goods_url })">
                <div class="good-img">
                  <figure>
                    <img :src="item.goods_img" alt="">
                  </figure>
                  <span class="serial-number">{{ index < 9 ? `0${index + 1}` : index + 1 }}</span>
                      <span class="explaining" v-if="+item.is_living">
                        <img src="https://s.kcimg.cn/live/image/speak.gif" alt="">
                        <!-- <i>&#xe603;</i> -->
                         <span>讲解中</span>
                      </span>
                      <div class="not-allow-buy" v-if="!item.goods_status || !item.total_quantity">
                        - {{ !item.goods_status ? '已下架' : '已售罄' }} -
                      </div>
                </div>
                <div class="desc">
                  <h5 class="com-two-line-els">{{ item.name }}</h5>
                  <p class="com-one-line-els">{{ item.sell_point }}</p>
                  <div class="bottom">
                    <!-- 已售罄/已下架 -->
                    <span class="price">
                      <template v-if="+item.active_price">
                        <span class="price-sign">¥</span>{{ item.active_price }}万
                      </template>
                    </span>
                    <button v-if="!item.goods_status || !item.total_quantity">{{ !item.goods_status ? '已下架' : '已售罄'
                    }}</button>
                    <div class="bring-color" :class="{ 'not-sell': !item.sell_status }"
                      v-if="item.sell_status < 2 && item.total_quantity && item.goods_status"
                      @click="jumpGoodDetail($event, item)">
                      <span><span class="price-sign">¥</span>{{ item.min_price }}</span>
                      <span v-if="item.sell_status === 1 && item.total_quantity">去抢购</span>
                      <span v-if="!item.sell_status">未开售</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <no-data v-if="isNoData" text="暂无商品" src="https://s.kcimg.cn/live/image/kzt_tongyong_kong.png"></no-data>
        </van-pull-refresh>
      </div>
    </div>
  </van-popup>
  <!-- </div> -->
</template>
<script>
import XHR from '../api'
import { callTel } from '../plugins/utils'
import pullDown from '../plugins/refresh/pullDown'
import { PullRefresh } from 'vant'
import PageLoading from '../plugins/loading/pageLoading'
import NoData from '../components/noData'

export default {
  name: 'GoodList',
  props: {
    rid: {
      type: String,
      default: ''
    }
  },
  components: {
    pullDown,
    [PullRefresh.name]: PullRefresh,
    PageLoading,
    NoData
  },
  data: () => ({
    goodList: [],
    rewardObj: {
      is_goal: '1',
      prize_img: ''
    },
    pageLoading: true,
    netWork: false,
    // 是否显示商品列表
    isShowGoodList: true,
    timer: null,
    isLoading: false,
    isNoData: false
  }),
  filters: {},
  created () {
    this.getCartList()
  },
  mounted () {
  },
  methods: {
    closePop () {
      this.$emit('close')
    },
    toCall () {
      callTel('4008596966')
    },
    // 滚动定位
    scrollLiving () {
      if (!document.getElementsByClassName('item-living').length) return
      document.getElementsByClassName('item-living')[0].scrollIntoView({
        block: 'start', // center表示将视口的中间和元素的中间对齐
        behavior: 'instant' // 直接滚到目标
      })
    },
    // 获取购物车列表
    getCartList (type = '') {
      const params = {
        rid: this.rid
      }
      if (type === 'refresh') {
        // 刷新loading
        this.isLoading = true
      }
      XHR.getCartList(params).then(res => {
        const { status, data } = res.data
        if (!status) {
          if (!data.list.length) {
            this.goodList = []
            this.isNoData = true
            if (type === 'refresh') {
              this.isLoading = false
            }
            if (this.pageLoading) {
              this.pageLoading = false
            }
            return
          }
          this.isNoData = false
          const idsArr = data.list.map(item => {
            return item.goods_id
          })
          this.getGoodsStatus(idsArr, data.list, type)
        }
      }).catch(() => {
        if (type === 'refresh') {
          this.isLoading = false
        }
        this.showErrorInfo('网络错误，请稍后重试')
      })
    },
    getGoodsStatus (idsArr = [], list = [], type = '') {
      const params = {}
      params.ids = idsArr.join(',')
      XHR.getGoodsStatus(params).then(res => {
        if (this.pageLoading) {
          this.pageLoading = false
        }
        if (type === 'refresh') {
          this.isLoading = false
        }
        const { status, data } = res.data
        if (status && data.length) {
          list.forEach(item => {
            const index = data.findIndex(statusItem => statusItem.goods_id === +item.goods_id)
            if (index > -1) {
              const time = new Date().getTime() / 1000
              if (time < data[index].sell_time) {
                // 未到开售时间
                data[index].sell_status = 0
              } else if (time > data[index].voluntarily_out_time || time === data[index].voluntarily_out_time) {
                data[index].sell_status = 2
              } else {
                // 商品售卖中
                data[index].sell_status = 1
              }
              item = Object.assign(item, data[index])
            }
          })
          this.goodList = list
          if (!type) {
            this.$nextTick(() => {
              this.scrollLiving()
            })
          }
        }
      }).catch(() => {
        if (type === 'refresh') {
          this.isLoading = false
        }
        this.showErrorInfo('网络错误，请稍后重试')
      })
    },
    jumpGoodDetail (event, item) {
      if (item.sell_status === 1) {
        event.stopPropagation()
        this.jumpOuterPage({ fullPath: item.link_href })
      }
    }
  }
}
</script>
<style scoped lang="less">
.van-popup-wrapper {
  border-radius: 16px 16px 0px 0px;
}

.snap-up {
  padding: 16px 7px;
  padding-bottom: calc(16px + constant(safe-area-inset-bottom)); ///兼容 IOS<11.2/
  padding-bottom: calc(16px + env(safe-area-inset-bottom)); ///兼容 IOS>11.2/
  box-sizing: border-box;
  background: #F8F9FB;
  border-radius: 16px 16px 0px 0px;

  .top {
    position: relative;
    display: flex;
    align-items: center;
    padding: 4px 0 10px;
    margin-left: 9px;
    margin-right: 9px;

    &.com-half-line::after {
      background: #DCDCDC;

    }

    .title {
      flex: 1;

      h3 {
        font-weight: 500;
        color: #03102A;
        line-height: 20px;
        font-size: 18px;
      }

      p {
        margin-top:5px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(3, 16, 42, 0.7);
        line-height: 14px;
      }
    }

    .operate {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 4px;
      margin-left: 16px;
      font-size: 10px;
      font-weight: 400;
      color: #03102A;
      line-height: 14px;

      i {

        font-family: 'icon-font';
        font-size: 18px;
      }

      span {
        margin-top: 2px;
        font-size: 10px;
        font-weight: 400;
        color: #03102A;
        line-height: 14px;

      }
    }

    .ask {
      margin-left: 0px;
    }
  }

  .list {
    height: calc(100vh - 270px);
  }

  .van-pull-refresh {
    height: 100%;
    overflow: auto;

    .pulling-box {
      padding: 5px 0;
    }

    .pulling-img {
      display: block;
      margin: auto;
      width: 72px;
    }
  }

  .snap-up-list {
    .item {
      display: flex;
      justify-content: space-between;
      padding: 10px;
      margin-top: 10px;
      background: #FFFFFF;
      border-radius: 8px;
      cursor: pointer;

      &.is-living {
        background: rgba(255, 147, 0, 0.1);
      }

      .good-img {
        flex-shrink: 0;
        position: relative;

        // border-radius: 8px;
        figure {
          width: 120px;
          height: 120px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
          }
        }

        .serial-number {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 100;
          width: 30px;
          height: 18px;
          line-height: 18px;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 8px 0px 8px 0px;
          font-size: 12px;
          font-weight: 400;
          color: #FFFFFF;
          text-align: center;
        }

        .explaining {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(255, 102, 0, 0.7);
          border-radius: 0px 0px 8px 8px;
          text-align: center;
          font-size: 12px;
          font-weight: 400;
          color: #FFFFFF;
         img{
            margin-top:4px;
            width:20px;
            height:20px;
          }
        }

        .not-allow-buy {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 100;
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(3, 16, 42, 0.4);
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 22px;
        }
      }

      .desc {
        position: relative;
        width: calc(100% - 150px);
        flex: 1;
        margin-left: 10px;

        h5 {
          // height: 44px;
          font-size: 16px;
          font-weight: 500;
          color: #03102A;
          line-height: 22px;
          word-break: break-all;
        }

        p {
          // height: 17px;
          margin-top: 4px;
          font-size: 12px;
          font-weight: 400;
          color: #FD6335;
          line-height: 17px;
          word-break: break-all;
        }
      }

      .bottom {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        // margin-top: 23px;
        .bring-color {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 132px;
          height: 28px;
          padding: 4px;
          box-sizing: border-box;
          background-image: url("https://s.kcimg.cn/live/image/qiang_new.png");
          background-size: 100%;

          &.not-sell {
            opacity: 0.4;
          }

          span {
            &:nth-of-type(1) {
              width: 80px;
              text-align: center;
              font-size: 14px;
              font-weight: 600;
              color: #FFFFFF;

              .price-sign {
                font-size: 10px;
              }
            }

            &:nth-of-type(2) {
              font-size: 12px;
              font-weight: 600;
              color: #FFFFFF;
              line-height: 17px;
              text-shadow: 0px 1px 1px #FF5400;
            }
          }
        }

        .price {
          font-size: 14px;
          font-weight: 600;
          color: #FF6600;
          line-height: 22px;

          .price-sign {
            font-size: 10px;
            line-height: 13px;
          }
        }

        button {
          width: 132px;
          height: 28px;
          border-radius: 4px;
          background: rgba(3, 16, 42, 0.1);
          font-size: 12px;
          font-weight: 600;
          color: rgba(3, 16, 42, 0.6);
          line-height: 17px;
          border-radius: 4px;
        }
      }
    }
    .item-living{
      padding-top:10px;
      .item{
        margin-top:0;
      }
    }
  }
}

/deep/ .page-loading {
  position: relative;
  background: #F8F9FB;
}

/deep/ .error-content {
  position: relative;
  background: #F8F9FB;
  height: auto;
  margin-top: 40px;
}

@media screen and (min-width: 751px) {
  .van-popup-wrapper {
    right: 0;
    width: 750px;
    margin: auto;
  }
}
</style>
